/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logOutAPI, validateToken } from 'src/api/modules/auth';
import notice from 'src/common/components/Notice';
import { actions as selectMenu } from 'src/redux/ducks/menu';
import { actions as selectOrgano } from 'src/redux/ducks/selectedCollegiateBody';
import store from 'src/redux/store';

export const useValidateToken = (isAuthorized) => {
	let resetMenu = {
		menu: {
			aside: {
				items: [
					{
						title: 'Inicio',
						icon: 'Home/Home.svg',
						slug: '/',
					},
				],
			},
		},
	};
	const dispatch = useDispatch();
	const onLogOut = async () => {
		try {
			const token = store.getState()?.auth?.user?.accessToken;
			await logOutAPI.post({ token });
			dispatch(selectOrgano.setOrgano(undefined));
			dispatch(selectMenu.setMenu(resetMenu.menu));
			localStorage.setItem('login', false);
			localStorage.clear();
			window.location.href = '/saoc-module-web/logout';
		} catch (error) {
			notice('Error', 'error');
		}
	};

	const onValidateToken = async () => {
		try {
			const token = store.getState()?.auth?.user?.accessToken;
			const response = await validateToken.post({ token });

			if (Number(response.tiempoRestante) <= 0 || !response.estatus) {
				notice('Su acceso ha vencido, vuelva a iniciar sesión', 'error');
				await onLogOut();
			}
		} catch (error) {
			notice('Error al validar token...', 'warning');
		}
	};

	useEffect(() => {
		if (isAuthorized) {
			const intervalId = setInterval(onValidateToken, 300000);
			return () => clearInterval(intervalId);
		}
	}, [isAuthorized]);
};
